export const EnvelopeIcon = () => {
    return (
        <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="80" height="80" rx="40" fill="#F4F2FF" />
            <path
                d="M56.8398 24.375C58.7573 24.375 60.3122 25.6184 60.3125 27.1523V52.8486C60.3123 54.3826 58.7574 55.626 56.8398 55.626L23.1602 55.627C21.2425 55.627 19.6875 54.3837 19.6875 52.8496V27.1543C19.6875 25.6202 21.2425 24.376 23.1602 24.376L56.8398 24.375ZM40.9893 42.7715C40.4137 43.2424 39.5863 43.2424 39.0107 42.7715L22.8125 29.5176V52.4502C22.8961 52.4783 23.0123 52.502 23.1602 52.502L56.8398 52.501C56.9877 52.501 57.1039 52.4764 57.1875 52.4482V29.5176L40.9893 42.7715ZM25.2803 27.5L40 39.5439L54.7197 27.5H25.2803Z"
                fill="#5F47F6"
            />
            <rect x="49" y="19" width="16" height="16" rx="8" fill="#C91C1C" />
        </svg>
    );
};
